module.exports = __webpack_public_path__ + "img/10.b0b30fbf.png";